import { useEffect, useState } from 'react';
import { getActiveVideoPublication, getVideoPublicationTasks, VIDEO_PUBLICATION_EVENT } from '../services/videoPublishingQueue';

export const useVideoPublishingStatus = (ownerId) => {
  const [tasks, setTasks] = useState(() => getVideoPublicationTasks());
  useEffect(() => {
    const refresh = () => setTasks(getVideoPublicationTasks());
    window.addEventListener(VIDEO_PUBLICATION_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(VIDEO_PUBLICATION_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);
  return {
    tasks: tasks.filter((task) => !ownerId || task.ownerId === ownerId),
    activeTask: getActiveVideoPublication(ownerId),
  };
};
